export default [
  'notification-body',
]
